import React, { type ReactNode } from 'react';

import { ModalTransition } from '@atlaskit/modal-dialog';

// @TODO: Remove this once migration is complete
export const ModalTransitionUniversal = ({ children }: { children: ReactNode }) => (
	<ModalTransition>{children}</ModalTransition>
);
